    import { createRouter, createWebHistory } from 'vue-router'

    import HomeView from '../views/HomeView.vue'

    import login from '../views/login.vue'

    import neworder from '../views/neworder.vue'

    import Branch from '../views/master/Branch.vue'

    import RoomCategory from '../views/master/RoomCategory.vue'

    import Products from '../views/master/products.vue'

    import services from '../views/master/services.vue'

    import cost from '../views/master/cost.vue'

    import orderlist from '../views/orderlist.vue'

    import orderDetails from '../views/orderDetails.vue'

    import customerlist from '../views/customerlist.vue'

    import customerDetails from '../views/customerDetails.vue'

    import user from '../views/master/user.vue'

    import profile from '../views/profile.vue'

    import report from '../views/report.vue'

    import accounting from '../views/accounting.vue'

    import singleaccounting from '../views/singleaccounting.vue'

    import allorderlist from '../views/allorderlist.vue'

    import accountinghistory from '../views/accountinghistory.vue'

    import register from '../views/register.vue'

    import registerlaundry from '../views/registerlaundry.vue'

    import daywisereport from '../views/daywisereport.vue'

    import deliverylist from '../views/deliverylist.vue'

    import addroom from '../views/addroom.vue'

    import roomview from '../views/roomview.vue'

    import roombooking from '../views/roombooking.vue'

    import roombookingdetails from '../views/roombookingdetails.vue'

    import AddClass from '../views/master/AddClass.vue'

    import AddStaff from '../views/master/AddStaff.vue'

    import AddStudent from '../views/master/AddStudent.vue'

    import Attendance from '../views/master/Attendance.vue'

    import AttendanceReport from '../views/master/AttendanceReport.vue'

    import StaffLogin from '../views/master/StaffLogin.vue'

    import StaffDashboard from '../views/master/StaffDashboard.vue'

    import ClassView from '../views/attentd/ClassView.vue'

    import AttendenceView from '../views/attentd/AttendenceView.vue'

    import ReportView from '../views/attentd/ReportView.vue'

    import StudentView from '../views/attentd/StudentView.vue'



    import subjectview from '../views/student/subject.vue'

    import examview from '../views/student/exam.vue'

    import questionview from '../views/student/question.vue'

    import addexamview from '../views/student/addexam.vue'

    import manageexamview from '../views/student/manageexamview.vue'

    import studentregistrationview from '../views/student/studentregistration.vue'

    import printpreview from '../views/student/printpreview.vue'

    import seassionview from '../views/student/seassion.vue'

    import accountingview from '../views/student/accounting.vue'

    import StudentDashboard from '../views/student/StudentDashboard.vue'
    
    import printaccounting from '../views/student/printaccounting.vue'

    import imagegallary from '../views/student/imagegallary.vue'

    import allstudresult from '../views/student/allstudresult.vue'

    import showresultadminView from '../views/student/showresultadminView.vue'

    import showcertificationadminView from '../views/student/showcertificationadminView.vue'

    import videogallary from '../views/student/videogallary.vue'







    //student routes

    import newsession from '../views/new_std/newsession.vue'

    import AttReportView from '../views/new_std/AttReportView.vue'

    import StudentAssignedExamView from '../views/new_std/StudentAssignedExamView.vue'
    import ExamtypelistView from '../views/new_std/Examtypelist.vue'
    import AttendExamView from '../views/new_std/AttendExam.vue'
    import showresultView from '../views/new_std/showresult.vue'
    import showcertificationView from '../views/new_std/showcertification.vue'
    import studentcertification from '../views/new_std/studentcertification.vue'
    import studentresult from '../views/new_std/studentresult.vue'
 
    
   


    const routes = [

        {

            path: '/home',

            name: 'home',

            component: HomeView

        },

    

        {

            path: '/orderDetails',

            name: 'orderDetails',

            component: orderDetails

        },

    

    {

            path: '/branch',

            name: 'Branch',

            component: Branch

        },

        {

            path: '/Products',

            name: 'Products',

            component: Products

        },

        {

            path: '/services',

            name: 'services',

            component: services

        },





        {

            path: '/cost',

            name: 'cost',

            component: cost

        },



        {

            path: '/',

            name: 'login',

            component: login

        },



        {

            path: '/login',

            name: 'loginpage',

            component: login

        },

        {

            path: '/neworder',

            name: 'neworder',

            component: neworder

        },





        {

            path: '/orderlist',

            name: 'orderlist',

            component: orderlist

        },





        {

            path: '/customerlist',

            name: 'customerlist',

            component: customerlist

        },



        {

            path: '/customerDetails',

            name: 'customerDetails',

            component: customerDetails

        },



        {

            path: '/user',

            name: 'user',

            component: user

        },



        {

            path: '/profile',

            name: 'profile',

            component: profile

        },



        {

            path: '/report',

            name: 'report',

            component: report

        },



        {

            path: '/accounting',

            name: 'accounting',

            component: accounting

        },





        {

            path: '/singleaccounting',

            name: 'singleaccounting',

            component: singleaccounting

        },





        {

            path: '/allorderlist',

            name: 'allorderlist',

            component: allorderlist

        },

        {

            path: '/accountinghistory',

            name: 'accountinghistory',

            component: accountinghistory

        },



        {

            path: '/register',

            name: 'register',

            component: register

        },



        {

            path: '/registerlaundry',

            name: 'registerlaundry',

            component: registerlaundry

        },



        {

            path: '/daywisereport',

            name: 'daywisereport',

            component: daywisereport

        },



        {

            path: '/deliverylist',

            name: 'deliverylist',

            component: deliverylist

        },





        {

            path: '/RoomCategory',

            name: 'RoomCategory',

            component: RoomCategory

        },



        {

            path: '/addroom',

            name: 'addroom',

            component: addroom

        },

        {

            path: '/roomview',

            name: 'roomview',

            component: roomview

        },

        {

            path: '/roombooking',

            name: 'roombooking',

            component: roombooking

        },

            {

            path: '/roombookingdetails',

            name: 'roombookingdetails',

            component: roombookingdetails

        },

                {

            path: '/AddClass',

            name: 'AddClass',

            component: AddClass

        },



        {

            path: '/AddStaff',

            name: 'AddStaff',

            component: AddStaff

        },

        {

            path: '/AddStudent',

            name: 'AddStudent',

            component: AddStudent

        },

            {

            path: '/Attendance',

            name: 'Attendance',

            component: Attendance

        },

            {

            path: '/AttendanceReport',

            name: 'AttendanceReport',

            component: AttendanceReport

        },



                {

            path: '/StaffLogin',

            name: 'StaffLogin',

            component: StaffLogin

        },



        {

            path: '/StaffDashboard',

            name: 'StaffDashboard',

            component: StaffDashboard

        },





        {

            path: '/ClassView',

            name: 'ClassView',

            component: ClassView

        },





        {

            path: '/AttendenceView',

            name: 'AttendenceView',

            component: AttendenceView

        },



            {

            path: '/ReportView',

            name: 'ReportView',

            component: ReportView

        },





        {

            path: '/StudentView',

            name: 'StudentView',

            component: StudentView

        },



    

        {

            path: '/subjectview',

            name: 'subjectview',

            component: subjectview

        },



        

        {

            path: '/examview',

            name: 'examview',

            component: examview

        },





            {

            path: '/questionview',

            name: 'questionview',

            component: questionview

        },



    

            {

            path: '/addexamview',

            name: 'addexamview',

            component: addexamview

        },  



    

    

            {

            path: '/manageexamview',

            name: 'manageexamview',

            component: manageexamview 

        },



        {

            path: '/studentregistrationview',

            name: 'studentregistrationview',

            component: studentregistrationview

        },

    

        {

            path: '/printpreview',

            name: 'printpreview',

            component: printpreview

        },



            {

            path: '/seassionview',

            name: 'seassionview',

            component: seassionview

        },



    

            {

            path: '/accountingview',

            name: 'accountingview',

            component: accountingview

        },



    // student



        {

            path: '/StudentDashboard',

            name: 'StudentDashboard',

            component: StudentDashboard

        },



        {

            path: '/newsession',

            name: 'newsession',

            component: newsession

        },







        {

           path: '/AttReportView',

           name: 'AttReportView',

           component: AttReportView

        },



        {

            path: "/StudentAssignedExamView",

            name: "StudentAssignedExamView",

            component: StudentAssignedExamView

        },



         {

            path: "/ExamtypelistView",

            name: "ExamtypelistView",

            component: ExamtypelistView
        },


           {

            path: "/AttendExamView",

            name: "AttendExamView",

            component: AttendExamView
        },
          {

            path: "/showresultView",

            name: "showresultView",

            component: showresultView
        },
  {

            path: "/showcertificationView",

            name: "showcertificationView",

            component: showcertificationView
        },

        
        {
            path: "/printaccounting",

                    name: "printaccounting  ",

                    component: printaccounting
                },

                   
        {
            path: "/studentcertification",

                    name: "studentcertification",

                    component: studentcertification
                },






           {
            path: "/studentresult",

                    name: "studentresult",

                    component: studentresult
                },

            {
                    path: "/allstudresult",

                    name: "allstudresult",

                    component: allstudresult
                },


                {
                    path: "/showresultadminView",

                    name: "showresultadminView",

                    component: showresultadminView
                },

                 {
                    path: "/showcertificationadminView",

                    name: "showcertificationadminView",

                    component: showcertificationadminView
                },

                 {
                    path: "/imagegallary",

                    name: "imagegallary",

                    component: imagegallary
                },

                   {
                    path: "/videogallary",

                    name: "videogallary",

                    component: videogallary
                },








        {

            path: '/about',

            name: 'about',

            // route level code-splitting

            // this generates a separate chunk (about.[hash].js) for this route

            // which is lazy-loaded when the route is visited.

            component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')

        }

    ]

    // Update the document title dynamically



    const router = createRouter({

        

        history: createWebHistory(process.env.BASE_URL),

        routes

    })



    export default router



